import type { ModuleRow } from '~/pages/backoffice/admin/modules/ModulesList'
import { useTranslation } from 'react-i18next'
import ConfirmDialog from '~/components/ConfirmDialog'

type Props = {
  module: Pick<ModuleRow, 'title'>
  onConfirm: () => void
  onCancel: () => void
}

/**
 * Un module supprimé part avec ses fichiers : rien ne se récupère (#210).
 * Monté le temps de la confirmation seulement : fermé, il ne garderait plus
 * rien à nommer pendant son animation de sortie.
 */
function ModuleDeleteDialog({ module, onConfirm, onCancel }: Props) {
  const { t } = useTranslation()

  return (
    <ConfirmDialog
      open
      title={t('modules.deleteTitle', { name: module.title })}
      confirmLabel={t('common.delete')}
      onConfirm={onConfirm}
      onCancel={onCancel}
    >
      {t('modules.deleteBody')}
    </ConfirmDialog>
  )
}

export default ModuleDeleteDialog
